import { Panel, PanelBody } from "components/Panel";
import GhgTotalEmissions from "./GhgTotalEmissions";
import GhgEmissionsBySource from "./GhgEmissionsBySource";

export default function GhgEmissions({ ghgResults, title = "GHG emissions" }) {
    if (!ghgResults) return null;

    return (
        <>
            <Panel title={title} skyBlue>
                <PanelBody className="u-print-noborder">
                    <GhgTotalEmissions ghgResults={ghgResults} title="Total emissions" />
                    <GhgEmissionsBySource ghgResults={ghgResults} title="Emissions by source" />
                </PanelBody>
            </Panel>
        </>
    )
}
